import { Card } from 'react-bootstrap';
import CallingActivityTimeline from 'components/timelines/CallingActivityTimeline';

const HVASystemActivityCard = () => {
  return (
    <Card className="hvasystem-card" style={{ height: '619px' }}>
      <Card.Body className="d-flex flex-column gap-2 scrollbar">
        <Card.Title className="mb-1 border-bottom">
          <h4 className="text-body-emphasis">Activity</h4>
          <p className="fs-9 fw-normal mb-2">Today's activity on HVA system</p>
        </Card.Title>
        <div className="h-100 p-2 pt-0 scrollbar">
          <CallingActivityTimeline />
        </div>
      </Card.Body>
    </Card>
  );
};

export default HVASystemActivityCard;
